export default (node) => {
  /**
   * Data + elements
   */
  const removePaddingTopItems = node.dataset.removePaddingTopItems === 'true';
  /**
   * Functions
   */

  const handleClick = (content, iconMinus, iconPlus) => {
    const currentStatus = content.getAttribute('aria-hidden') === 'true';
    const isCourseVideo = content.dataset.isCourseVideo === 'true';
    const renderCourseVideo = content.dataset.isCourseVideoRender === 'false';
    const isCourseVideoHandle = content.dataset.isCourseVideoHandle
      ? content.dataset.isCourseVideoHandle
      : 'x';
    content.setAttribute(
      'aria-hidden',
      content.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'
    );
    iconMinus.classList.toggle('hidden');
    iconPlus.classList.toggle('hidden');

    setTimeout(
      () => {
        if (!removePaddingTopItems) content.classList.toggle('pt-5');
        content.classList.toggle('pb-4');

        if (isCourseVideo && renderCourseVideo) {
          const event = new CustomEvent('course-video:open', {
            detail: isCourseVideoHandle,
          });
          document.dispatchEvent(event);
          content.dataset.isCourseVideoRender = 'true';
        }
      },
      currentStatus ? 0 : 250
    );
  };

  const initEventListeners = (e) => {
    let nodeTemp = node;
    if (e && e.detail && e.detail.node) {
      nodeTemp = e.detail.node;
    }
    const accordionItems = nodeTemp.querySelectorAll('[data-accordion-item]');
    accordionItems.forEach((item) => {
      const accordionButton = item.querySelector('[data-accordion-button]');
      const accordionContent = item.querySelector('[data-accordion-content]');
      const iconPlus = item.querySelector('[data-accordion-icon-plus]');
      const iconMinus = item.querySelector('[data-accordion-icon-minus]');
      accordionButton.addEventListener('click', () =>
        handleClick(accordionContent, iconMinus, iconPlus)
      );

      // check if the item is open by default
      if (item.dataset.setOpen && item.dataset.setOpen === 'true') {
        handleClick(accordionContent, iconMinus, iconPlus);
      }
    });
  };

  /**
   * Init
   */
  const init = () => {
    initEventListeners();
    document.addEventListener('accordion:init', initEventListeners);
  };

  init();
};
